import { z } from "zod";

export const oauthTokensSchema = z.object({
	access_token: z.string(),
	refresh_token: z.string().optional(),
	expires_in: z.number(),
});

export type OAuthTokens = z.infer<typeof oauthTokensSchema>;
